module.exports = __webpack_public_path__ + "12faadca03fdfe699d03c267f91910.png";